<template>
    <!--采购页面-->
    <div>
        <el-card class="box-card" style="margin-bottom: 10px">
            <div slot="header" class="clearfix">
                <span>采购项目信息</span>
            </div>
            <template>
                <el-form label-width="175px" class="form viewFormWrapper" style="margin-bottom: 10px">
                    <el-row>
                        <el-col :span="24">
                            <el-form-item label="采购项目名称：">
                                <span >{{projectInfo.purchaseProjectName }}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="采购项目编号：" >
                                <span >{{projectInfo.purchaseProjectCode }}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="投资项目统一代码：" >
                                <span >{{projectInfo.investProjectCode }}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="采购项目类型：" >
                                <span >{{projectInfo.tenderProjectTypeName }}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="委托类型：" >
                                <span >{{projectInfo.entrustTypeName }}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="采购方式：" >
                                <span >{{projectInfo.purchaserModeName }}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="采购组织形式：" >
                                <span >{{projectInfo.purchaserOrganizeFormName }}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="所属区域：" >
                                <span >{{projectInfo.region }}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="所属行业：" >
                                <span >{{projectInfo.industry }}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="PPP项目：" >
                                <span >{{projectInfo.isProject == '1'?'是':'否' }}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="监管部门：" >
                                <span >{{projectInfo.superviseDeptName }}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="监管社会信用统一代码：" >
                                <span >{{projectInfo.superviseCreditUniformCode }}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="网站栏目：" >
                                <span >{{projectInfo.websiteProgramaName }}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="项目建立时间：" >
                                <span >{{formatDate(projectInfo.createTime,'yyyy-MM-dd HH:mm:ss') }}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="采购内容：" >
                                <el-input
                                        type="textarea"
                                        disabled
                                        :autosize="{ minRows: 2, maxRows: 6}"
                                        v-model="projectInfo.purchaserContent">
                                </el-input>
                            </el-form-item>
                        </el-col>

                    </el-row>
                </el-form>
            </template>
        </el-card>

        <el-card class="box-card" style="margin-bottom: 10px">
            <div slot="header" class="clearfix">
                <span>代理机构信息</span>
            </div>
            <template>
                <el-form label-width="150px" class="form viewFormWrapper" style="margin-bottom: 10px">
                    <el-row>
                        <el-col :span="24">
                            <el-form-item label="采购代理机构：">
                                <span >{{projectInfo.purchaserAgencyName }}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="联系人：" >
                                <span >{{projectInfo.purchaserAgencyConnector }}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="联系电话：" >
                                <span >{{projectInfo.purchaserAgencyPhone }}</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </template>
        </el-card>

        <el-card class="box-card" style="margin-bottom: 10px">
            <div slot="header" class="clearfix">
                <span>包件（标段）信息</span>
            </div>
            <template>
                <div v-for="(item,index) in tableDataCopy" :key="item.id" class="dataWrapper" >
                    <div class="iconToolbar-left">
                        {{indexMethodNoPage(index)}}
                    </div>
                    <el-form label-width="150px" class="form viewFormWrapper" style="margin-bottom: 10px">
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="包件名称：" >
                                    <span >{{item.purchaseProjectName }}</span>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="包件编码：" >
                                    <span >{{item.purchaseSectionCode }}</span>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="预算总价：" >
                                    <span >{{(item.programBudgetCurrencyName || '')  + (item.programBudget || '') + (item.programBudgetUnitName || '') }}</span>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="开标版本：" >
                                    <span >{{item.bidOpenVersion }}</span>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24" style="margin-bottom:16px">
                                <el-form-item label="供应商资格要求：" >
                                    <el-input
                                            type="textarea"
                                            disabled
                                            :autosize="{ minRows: 2, maxRows: 6}"
                                            placeholder="请输入内容"
                                            v-model="item.supplierQualificationRequired">
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-table
                                    :data="item.bidSectionPartList"
                                    border
                                    style="width: 100%;">
                                <el-table-column width="50" label="序号" type="index" :index="indexMethodNoPage" align="center"></el-table-column>
                                <el-table-column
                                        header-align="center"
                                        align="center"
                                        width="100"
                                        label="操作">
                                    <template slot-scope="scope">
                                        <el-button type="text" size="small" @click="showDetail(scope.row.id)">查看</el-button>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                        prop="purchaseContent"
                                        header-align="center"
                                        :show-overflow-tooltip="true"
                                        align="left"
                                        label="采购内容">
                                </el-table-column>
                                <el-table-column
                                        prop="purchaserName"
                                        :show-overflow-tooltip="true"
                                        header-align="center"
                                        label="采购人">
                                </el-table-column>
                                <el-table-column
                                        prop="tenderProjectTypeName"
                                        :show-overflow-tooltip="true"
                                        align="center"
                                        label="采购类别">
                                </el-table-column>
                                <el-table-column
                                        prop="entrustTypeName"
                                        :show-overflow-tooltip="true"
                                        align="center"
                                        label="委托类型">
                                </el-table-column>
                                <el-table-column
                                        prop="number"
                                        width="134px"
                                        align="center"
                                        label="采购数量（单位）">
                                    <template slot-scope="scope" >
                                        <span>{{scope.row.number + "（" + scope.row.numberUnit + "）"}}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                        prop="budgetAmount"
                                        width="120px"
                                        align="center"
                                        label="预算（单位）">
                                    <template slot-scope="scope" >
                                        <span>{{scope.row.budgetAmount + "（" + ( scope.row.budgetUnitName || '' ) + "）"}}</span>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-row>
                    </el-form>
                </div>
                <p style="text-align: center" v-if="tableData.length == 0">暂无标段（包件）数据</p>
<!--                <el-pagination background-->
<!--                               layout="sizes, prev, pager, next"-->
<!--                               :page-sizes="[pageSize, 20, 50, 100]"-->
<!--                               :page-size="pageSize"-->
<!--                               :total="total"-->
<!--                               :current-page="pageIndex"-->
<!--                               @size-change="sizeChangeHandle"-->
<!--                               @current-change="currentChangeHandle"></el-pagination>-->
            </template>
        </el-card>

        <el-dialog  title="采购件详情" :visible.sync="dialogPersonVisible" width="80%">
            <div class="dialogBox" v-loading="dialogFormDataLoading">
                <el-card class="box-card" style="margin-bottom: 10px">
                    <div slot="header" class="clearfix">
                        <span>采购件信息</span>
                    </div>
                    <template>
                        <el-form label-width="170px" class="form viewFormWrapper" style="margin-bottom: 10px">
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="采购内容：" >
                                        <span >{{dialogFormInfo.purchaseContent }}</span>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="采购类别：" >
                                        <span >{{dialogFormInfo.tenderProjectTypeName }}</span>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="采购方式：" >
                                        <span >{{dialogFormInfo.purchaserModeName }}</span>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="委托类型：" >
                                        <span >{{dialogFormInfo.entrustTypeName }}</span>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="采购组织形式：" >
                                        <span >{{dialogFormInfo.purchaserOrganizeFormName }}</span>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="数量：" >
                                        <span >{{dialogFormInfo.number }}</span>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="24">
                                    <el-form-item label="数量单位：" >
                                        <span >{{dialogFormInfo.numberUnit }}</span>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="24">
                                    <el-form-item label="规格、型号及技术指标：" >
                                        <span >{{dialogFormInfo.technicalIndicator }}</span>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="24">
                                    <el-form-item label="备注：" >
                                        <el-input
                                                type="textarea"
                                                disabled
                                                :autosize="{ minRows: 2, maxRows: 6}"
                                                v-model="dialogFormInfo.remark">
                                        </el-input>
                                    </el-form-item>
                                </el-col>

                            </el-row>
                        </el-form>
                    </template>
                </el-card>
                <el-card class="box-card" style="margin-bottom: 10px">
                    <div slot="header" class="clearfix">
                        <span>资金来源</span>
                    </div>
                    <template>
                        <el-form label-width="150px" class="form viewFormWrapper" style="margin-bottom: 10px">
                            <el-row>
                                <el-col :span="24">
                                    <el-form-item label="预算总额：">
                                        <span >{{( dialogFormInfo.budgetCurrencyName || '' ) + dialogFormInfo.budgetAmount + (dialogFormInfo.budgetUnitName || '')  }}</span>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                    </template>
                </el-card>
                <el-card class="box-card" style="margin-bottom: 10px">
                    <div slot="header" class="clearfix">
                        <span>采购人信息</span>
                    </div>
                    <template>
                        <el-form label-width="150px" class="form viewFormWrapper" style="margin-bottom: 10px">
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="采购人名称：">
                                        <span >{{dialogFormInfo.purchaserName }}</span>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="采购人代码：">
                                        <span >{{dialogFormInfo.purchaserCode }}</span>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="联系人：" >
                                        <span >{{dialogFormInfo.contactName }}</span>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="联系电话：" >
                                        <span >{{dialogFormInfo.contactPhone }}</span>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                    </template>
                </el-card>
                <el-card class="box-card" style="margin-bottom: 10px">
                    <div slot="header" class="clearfix">
                        <span>附件信息</span>
                    </div>
                    <template>
                        <div class="affixDown" v-if="(dialogFormInfo.attachments && dialogFormInfo.attachments.length > 0)" style="margin-bottom: 10px">
                            <affix-doc v-for="(item,index) in dialogFormInfo.attachments"
                                       labelWidth="150px"
                                       :item.sync="item"
                                       :index="index"
                                       :showModal="false"
                                       :key="index"
                                       :name="item.titleName || '相关附件'"></affix-doc>
                        </div>
                    </template>
                </el-card>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogPersonVisible=false" class="backBtn">返回</el-button>
          </span>
        </el-dialog>

    </div>



</template>

<script>
    import affixDoc from '@/components/affixDoc';
    import $ from "jquery";

    export default {
        components: {
            affixDoc
        },
        props:{
            nodeCode:{
                type:String,
                defalut:'GC00014'
            },
            purchaserMode:{
                type:String,
                defalut:''
            },
            title:{
                type:String,
                defalut:''
            },
            total:{
                type:Number,
                defalut:0
            },
            projectInfo:{
                type:Object,
                default:()=>({})
            },
            tableData:{
                type:Array,
                default:()=>([])
            },
            dataListLoading:{
                type:Boolean,
                defalut:false
            },

        },
        watch:{
            nodeCode:{
                immediate: true,
                handler (val) {
                    this.nodeCodeCopy = val
                },
                deep: true
            },
            tableData: {
                immediate: true,
                handler (val) {
                    this.tableDataCopy = val
                },
                // 这里是关键，代表递归监听 demo 的变化
                deep: true
            },
        },
        data() {
            return {
                keywords:"",
                pageSize:10,//每页条数
                pageIndex:1,//当前页
                tableDataCopy:[],
                dialogPersonVisible:false,
                dialogFormInfo:{},
                dialogFormDataLoading:false,
                nodeCodeCopy:"",
            }
        },
        activated() {

        },
        methods: {
            indexMethodNoPage(index) {
                return index + 1
            },
            showDetail(id){
                this.dialogPersonVisible = true;
                this.dialogFormDataLoading = true;
                this.$http.get(`/cg/nonCustomForm/getBidSectionPart?id=${id}`).then(({ data }) => {
                    this.dialogFormDataLoading = false;
                    if (data.code == "1") {
                        this.dialogFormInfo = data.data;
                        let attachmentTemp = [];
                        for(var key in data.data.fileTypeMap){
                            let obj = JSON.parse(JSON.stringify(data.data.fileTypeMap[key]))
                            obj.titleName = key;
                            attachmentTemp.push(obj);
                        }
                        if(data.data.attachments.length > 0){
                            data.data.attachments.forEach((item)=>{
                                let index = attachmentTemp.findIndex((val) => val.fileType == item.fileType);
                                if(index > 0){
                                    attachmentTemp[index] =  {...item};
                                }
                            })
                        }
                        this.dialogFormInfo.attachments = attachmentTemp;


                    } else{
                        this.dialogFormInfo = {};
                    }
                });
            },

            fileDownload(filePath, fileName) {
                if (filePath) {
                    var a = document.createElement('a');
                    a.download = fileName;
                    a.target = "_Blank";
                    a.href = filePath;
                    $("body").append(a);
                    a.click();
                    $(a).remove();
                }
            },
            getCustomData(){
                this.pageIndex = 1;
                this.pageSize = 10;
                this.$emit('queryCustomFormData',{pageSize:this.pageSize,pageIndex:this.pageIndex,keywords:this.keywords})
            },
            sizeChangeHandle(val) {
                this.pageSize = val;
                this.pageIndex = 1;
                this.$emit('queryCustomFormData',{pageSize:this.pageSize,pageIndex:this.pageIndex,keywords:this.keywords})
            },
            currentChangeHandle(val) {
                this.pageIndex = val;
                this.$emit('queryCustomFormData',{pageSize:this.pageSize,pageIndex:this.pageIndex,keywords:this.keywords})
            },
        }







    }
</script>

<style lang="less" scoped>

    .dataWrapper{
        position: relative;
        border-bottom: 1px solid #ebeef5;
        margin-bottom: 10px;
        &:last-child{
            border-bottom: none;
        }
        .iconToolbar-left{
            font-weight: bold;
            color: #fff;
            text-align: center;
            padding-top: 3px;
            position: absolute;
            top: 10px;
            left: 0px;
            width: 32px;
            height: 32px;
            background:url("../../assets/img/bookmark.png")no-repeat;
        }
    }
    .dataWrapper:last-child{
        border-bottom: none;
    }

</style>
